const getUserProfileAssignedClientsLoadingStatus = (state) => {
  return state.pages.profile.isLoadingClients;
};

const getUsersAssignedClients = (state) => {
  return state.pages.profile.clientsAssignedToUser;
};

export { getUserProfileAssignedClientsLoadingStatus, getUsersAssignedClients };
